<script>
import Layout from '@layouts/main'
import { merchantComputed } from '@state/helpers'

export default {
  page() {
    return {
      title: '404',
    }
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...merchantComputed,
  },
}
</script>

<template>
  <Layout>
    <BaseContainer>
      <div class="defaultBox">
        <img alt="merchant default" class="defaultBox__image" src="@assets/images/information_default.png" />
        <h1 class="defaultBox__text">
          404: <template v-if="resource">{{ resource }}</template> Not Found
        </h1>
        <router-link
          class="button is-primary is-rounded fix-width-200"
          :to="{
              name: 'home',
              params: { merchantAlias: currentMerchant.alias },
              query: {
                language: $route.query.language,
              },
            }"
        >
          返回{{ currentMerchant.name }}
        </router-link>
      </div>
    </BaseContainer>
    <!--<section class="hero is-light">
      <div class="hero-body">
        <div class="containe has-text-centeredr">
          <h1 class="title">404</h1>
          <h2 class="subtitle">
            <template v-if="resource">{{ resource }}</template> Not Found
          </h2>
        </div>
      </div>
    </section>-->
  </Layout>
</template>
